import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';

// Code splitting(via dynamic importing) allows the app to load faster as each dynamic
// component and it's dependencies aren't loaded till needed.
// https://reactjs.org/docs/code-splitting.html
const Dashboard = lazy(() => import('@/features/dashboard'));
const notAuthorized = lazy(() => import('@/app/not-authorized'));
const adminClients = lazy(() => import('@/features/clients/components'));
const adminClientDetails = lazy(
  () => import('@/features/clients/components/client-detail'),
);
const ocrMaps = lazy(() => import('@/features/ocr-maps/components'));

const Routes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Switch>
      <Route exact={true} path={'/'} component={Dashboard} />
      <Route exact={true} path={'/clients'} component={adminClients} />
      <Route path={'/clients/:id'} component={adminClientDetails} />
      <Route path={'/ocr-maps'} component={ocrMaps} />
      <Route path={'/not-authorized'} component={notAuthorized} />
    </Switch>
  </Suspense>
);

export default Routes;
